module.exports = __webpack_public_path__ + "img/wz-8-2-5.6e709abf.jpg";